import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RecordsService } from '../services/records.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-statistic',
  templateUrl: './statistic.component.html',
  styleUrls: ['./statistic.component.css']
})
export class StatisticComponent implements OnInit {
  
  public index:number = 0;
  public years:Array<any> = [];
  public years2:Array<any> = [];
  public curryear:number = new Date().getFullYear();
  public paysedition: any;
  public langueSource: any;
  public langueCible: any;
  public themes: any;
  public subthemes: any;
  public themesel: any;
  public listnat: any;
  public currentlang:string = 'ara';

  private link:string = "http://trad.fondation.org.ma:8090/api/";

  public auteur:string = '';
  public sexe:string = '';
  public nat:string = '';
  public pays_org:string = '';
  public langsource:string = '';
  public langcible:string = '';
  public theme:string = '';
  public themeg:string = '';
  public first:string = '';
  public end:string = '';
  public charts:String = '';
  public chartall: boolean;
  public limit:number = 10;
  public total:number = 0;
  public totala:number = 0;
  public totalda:number = 0;

  public linkediteur: string;
  public linkdescip: string;
  public linkpays: string;
  public linkyears: string;
  public linklangsrc: string;
  public linklangcib: string;
  public linktm: string;
  public linkdme: string;
  public linkta: string;
  public linktda: string;
  public linkcount:string;
  public linkcounta:string;
  public linkcountda:string;
  public shs: boolean = true;
  public lmg: boolean = false;
  chartrequired: boolean = false;

  constructor(public recordService: RecordsService, public router: Router, public translate: TranslateService,private httpClient: HttpClient) { 
    this.translate.onLangChange.subscribe((lang) => {
      this.currentlang = (lang.lang == 'fr') ? 'fre' : 'ara';
      this.paysedition= [];
      this.langueSource= [];
      this.langueCible= [];
      this.themes= [];
      this.listnat= [];
      this.nat = '';
      this.pays_org = '';
      this.langsource = '';
      this.langcible = '';
      this.theme = '';
      // this.getPaysEditions();
      // this.getLangCible();
      // this.getLangSource();
      // this.getThemes();
      // this.getNat();
      this.nat = '';
      this.pays_org = '';
      this.langsource = '';
      this.langcible = '';
      this.theme = '';
      this.linkediteur = this.link+'statistic/editeur/';
      this.linkdescip = this.link+'statistic/matiere/';
      this.linkpays = this.link+'statistic/paysedition_'+this.currentlang+'/';
      this.linkyears = this.link+'statistic/anneeedition/';
      this.linklangsrc = this.link+'statistic/Langsource/';
      this.linklangcib = this.link+'statistic/langcible/';
      this.linktm = this.link+'statistic/anneeedition/';
      this.linkdme = this.link+'statistic/dme/';
      this.linkta = this.link+'statistic/ta/';
      this.linktda = this.link+'statistic/tda/';
      this.linkcount = this.link+'statistic/cnt/';
      this.linkcounta = this.link+'statistic/cnta/';
      this.linkcountda = this.link+'statistic/cntd/';
    });
    // console.log(this.currentlang);
  }

  ngOnInit(): void {
    this.index=0;
    for(let i=this.curryear; i>=1600; i--)
    {
      this.years[this.index] = i;
      this.index++;
    }
    this.index=0;
    for(let i=this.curryear; i>=1600; i--)
    {
      this.years2[this.index] = i;
      this.index++;
    }
    this.getPaysEditions();
    this.getLangCible();
    this.getLangSource();
    this.getThemes();
    this.getNat();
    
    this.httpClient.get(this.linkcount).subscribe(res => { 
      //console.log(res);
      this.total = parseInt(JSON.stringify(res))
    });
    this.httpClient.get(this.linkcounta).subscribe(res => { 
      //console.log(res);
      this.totala = parseInt(JSON.stringify(res))
    });
    this.httpClient.get(this.linkcountda).subscribe(res => { 
      //console.log(res);
      this.totalda = parseInt(JSON.stringify(res))
    });
  }
  
  onchangeDate(value:number) {
    this.years2 = [];
    this.index=0;
    for(let i=this.curryear; i>=value; i--)
    {
      this.years2[this.index] = i;
      this.index++;
    }
  }

  public getPaysEditions(){
    console.log(this.link+'paysedition/' +this.translate.currentLang);
    
      this.recordService.getFilters(this.link+'paysedition/' +this.translate.currentLang + '/' + this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.paysedition = data;
      }, err =>{
        console.log(err);
      });
  }

  public getNat(){
      this.recordService.getFilters(this.link+'listnat/'+this.translate.currentLang + '/'+ this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.listnat = data;
      }, err =>{
        console.log(err);
      });
  }
  public getLangSource(){
    if(this.translate.currentLang=='ar') {
      this.recordService.getFilters(this.link+'listlanguesourcea/'+ this.translate.currentLang + '/' + this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.langueSource = data;
      }, err =>{
        console.log(err);
      });
    } else {
      this.recordService.getFilters(this.link+'listlanguesourcea/' +this.translate.currentLang + '/' + this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.langueSource = data;
      }, err =>{
        console.log(err);
      });
    }
  }

  public getLangCible(){
    if(this.translate.currentLang=='ar') {
      this.recordService.getFilters(this.link+'listlangueciblea/' +this.translate.currentLang + '/' + this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.langueCible = data;
      }, err =>{
        console.log(err);
      });
    } else {
      this.recordService.getFilters(this.link+'listlangueciblea/' +this.translate.currentLang + '/'+ this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.langueCible = data;
      }, err =>{
        console.log(err);
      });
    }
  }

  public getThemes(){
    if(this.translate.currentLang=='ar') {
      this.recordService.getFilters(this.link+'listthemes/' +this.translate.currentLang + '/'+ this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.themes = data;
      }, err =>{
        console.log(err);
      });
    } else {
      this.recordService.getFilters(this.link+'listthemes/' +this.translate.currentLang + '/'+ this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.themes = data;
      }, err =>{
        console.log(err);
      });
    }
  }

  public getSubtheme(val) {
    if(this.translate.currentLang=='ar') {
      this.recordService.getFilters(this.link+'listsubthemes/' + val + '/' +this.translate.currentLang + '/'+ this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.subthemes = data;
      }, err =>{
        console.log(err);
      });
    } else {
      this.recordService.getFilters(this.link+'listsubthemes/' + val + '/' +this.translate.currentLang + '/'+ this.shs + '/' + this.lmg)
      .subscribe(data => {
        this.subthemes = data;
      }, err =>{
        console.log(err);
      });
    }
  }

  onSearch(value: any) {
    this.chartrequired = false;
    if(value.chartselect!="") {
      if(value.auteur) this.auteur = value.auteur; else this.auteur=" ";
      if(value.paysedition) this.pays_org = value.paysedition; else this.pays_org=" ";
      if(value.first) this.first = value.first; else this.first="1600";
      if(value.end) this.end = value.end; else this.end = this.curryear.toString();
      if(value.langsource) this.langsource = value.langsource; else this.langsource=" ";
      if(value.langcible) this.langcible = value.langcible; else this.langcible=" ";
      if(value.theme) this.theme = value.theme; else this.theme=" ";
      if(value.themeg) this.themeg = value.themeg; else this.themeg=" ";
      if(value.sexe) this.sexe = value.sexe; else this.sexe=" ";
      if(value.nat) this.nat = value.nat; else this.nat=" ";
      if(value.limit) this.limit = value.limit; else this.limit=10;
      if(value.chartselect) this.charts = value.chartselect; else this.charts="ALL";

      this.linkediteur = this.link+'statistic/editeur/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linkdescip = this.link+'statistic/matiere/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linkpays = this.link+'statistic/paysedition_'+this.currentlang+'/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linkyears = this.link+'statistic/anneeedition/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linklangsrc = this.link+'statistic/Langsource/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linklangcib = this.link+'statistic/langcible/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linktm = this.link+'statistic/tm/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linkdme = this.link+'statistic/dme/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linkta = this.link+'statistic/ta/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linktda = this.link+'statistic/tda/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linkcount = this.link+'statistic/cnt/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linkcounta = this.link+'statistic/cnta/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      this.linkcountda = this.link+'statistic/cntd/'+this.auteur+'/'+this.sexe+'/'+this.nat+'/'+this.pays_org+'/'+this.langsource+'/'+this.langcible+'/'+this.theme+'/'+this.themeg+'/'+this.first+'/'+this.end+'/'+this.limit + '/' + this.shs + '/' + this.lmg;
      
      this.httpClient.get(this.linkcount).subscribe(res => { 
        //console.log(res);
        this.total = parseInt(JSON.stringify(res))
      });
      this.httpClient.get(this.linkcounta).subscribe(res => { 
        //console.log(res);
        this.totala = parseInt(JSON.stringify(res))
      });
      this.httpClient.get(this.linkcountda).subscribe(res => { 
        //console.log(res);
        this.totalda = parseInt(JSON.stringify(res))
      });
      // console.log(this.linkcount);
    } else this.chartrequired = true;
    
  }

  changeShs(e: any) {
    this.shs = e.target.checked;
    this.recordService.shs = e.target.checked;
  }

  changeLmg(e: any) {
    this.lmg = e.target.checked;
    this.recordService.lmg = e.target.checked;
  }

}
